"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKpiDrill = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var drill_1 = require("../../../drill");
var model_1 = require("../../../../model");
/**
 * Returns a drill handler for a given KPI.
 *
 * @param kpiWidget - widget the drills of which to handle
 * @internal
 */
function useKpiDrill(kpiWidget) {
    var disableDefaultDrills = model_1.useDashboardSelector(model_1.selectDisableDefaultDrills);
    var handleDrillToLegacyDashboard = drill_1.useDrillToLegacyDashboard().run;
    var handleDrill = drill_1.useDrill({
        onSuccess: function (event) {
            if (disableDefaultDrills || !event.payload.drillEvent.drillDefinitions[0]) {
                return;
            }
            handleDrillToLegacyDashboard(event.payload.drillEvent.drillDefinitions[0], event.payload.drillEvent, event.correlationId);
        },
    }).run;
    return react_1.useCallback(function (event) {
        handleDrill(event, { widget: kpiWidget });
    }, [handleDrill, kpiWidget]);
}
exports.useKpiDrill = useKpiDrill;
//# sourceMappingURL=useKpiDrill.js.map